// extracted by css-extract-rspack-plugin
export default {"input":"HydratedKBarSearch-module__input___sFH1J"};